import {
  ComponentType,
  SystemType,
  WitboostComponent,
  WitboostSystem,
} from '@agilelab/plugin-wb-builder-common';
import { Entity } from '@backstage/catalog-model';
import { PracticeShaperApi } from './api';

export function isSystemType(entity: Entity): entity is SystemType {
  return entity.kind.toLocaleLowerCase('en-US') === 'systemtype';
}

export function isSystemInstance(entity: Entity): entity is WitboostSystem {
  return entity.kind.toLocaleLowerCase('en-US') === 'system';
}

export function isComponentType(entity: Entity): entity is ComponentType {
  return entity.kind.toLocaleLowerCase('en-US') === 'componenttype';
}

export function isComponentInstance(
  entity: Entity,
): entity is WitboostComponent {
  return entity.kind.toLocaleLowerCase('en-US') === 'component';
}

export const componentTypeResolverFn = async ({
  practiceShaperApi,
}: {
  practiceShaperApi: PracticeShaperApi;
}) => {
  const response = await practiceShaperApi.getComponentTypes({
    filter: { isAbstract: false },
  });
  const valueToLabel = new Map<string, string>();
  const values = response.items.map(i => {
    valueToLabel.set(
      i.metadata.name,
      i.metadata.displayName ?? i.metadata.name,
    );
    return i.metadata.name;
  });

  return { values, valueToLabel };
};

export const systemTypeResolverFn = async ({
  practiceShaperApi,
}: {
  practiceShaperApi: PracticeShaperApi;
}) => {
  const response = await practiceShaperApi.getSystemTypes({
    filter: { isAbstract: false },
  });
  const valueToLabel = new Map<string, string>();
  const values = response.items.map(i => {
    valueToLabel.set(
      i.metadata.name,
      i.metadata.displayName ?? i.metadata.name,
    );
    return i.metadata.name;
  });

  return { values, valueToLabel };
};

export function hasOneOfTeamRoles(entity: Entity): entity is SystemType {
  return (
    isSystemType(entity) &&
    !!(
      entity.spec.isOwnedBy ||
      entity.spec.dataAccessGrantedBy ||
      entity.spec.isDevelopedBy
    )
  );
}
